export var DeleteSubscriptionError;
(function (DeleteSubscriptionError) {
})(DeleteSubscriptionError || (DeleteSubscriptionError = {}));
var DeleteSubscriptionRequest = /** @class */ (function () {
    function DeleteSubscriptionRequest(id) {
        this.knownErrorCodes = Object.values(DeleteSubscriptionError);
        this.method = 'delete';
        this.path = "my/info-card-subscriptions/".concat(encodeURIComponent(id));
    }
    return DeleteSubscriptionRequest;
}());
export { DeleteSubscriptionRequest };
